<template>
  <div :class="`animation animation-${loaded ? 'loaded' : 'wait'} animation-cubes animation-cubes-${theme}`">
    <cubes-svg/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

import CubesSvg from '@/components/Animation/CubesSvg';

export default {
  props: ['inViewport'],

  components: {
    CubesSvg,
  },

  computed: mapGetters({
    loaded: 'loaded',
    theme: 'theme',
  }),

  watch: {
    theme() {
      clearTimeout(this.disableTimeout);
      if (this.inViewport) {
        this.disableAnimation = false;
        this.checkCurrentTheme();
      } else {
        this.disableTimeout = setTimeout(() => {
          this.disableAnimation = true;
          this.checkCurrentTheme();
        }, 3000);
      }
    },
  },

  data() {
    return {
      timeoutsAnimation: {},
      disableAnimation: false,
      disableTimeout: null,
      cubesBottomWrap: null,
      cubesMiddleWrap: null,
      cubesTopWrap: null,
      timing: 900,
      cubesBottom: [],
      cubesMiddle: [],
      cubes: [],
    };
  },

  mounted() {
    const cubes = window.SVG.select('#cubes-wrap');
    cubes.opacity(0);

    if (this.theme === 'dark') {
      this.disableAnimation = true;
      this.timing = 1;
    }

    setTimeout(() => {
      setTimeout(() => {
        this.disableAnimation = false;
        this.timing = 900;
        cubes.animate(200).opacity(1);
      }, 100);
      this.initSVG();
    }, 200);
  },

  methods: {
    initSVG() {
      const SVG = window.SVG;
      this.cubes = [
        {
          root: SVG.select('#cubes-up-cub-01'),
          transform: {
            translate: {
              x: -324,
              y: 194,
            },
          },
        },
        {
          root: SVG.select('#cubes-up-cub-02'),
          transform: {
            translate: {
              x: 138,
              y: 141,
            },
          },
        },
        {
          root: SVG.select('#cubes-up-cub-03'),
          transform: {
            translate: {
              x: -222,
              y: 18,
            },
          },
        },
        {
          root: SVG.select('#cubes-up-cub-04'),
          transform: {
            translate: {
              x: 266,
              y: -24,
            },
          },
        },
        {
          root: SVG.select('#cubes-up-cub-05'),
          transform: {
            translate: {
              x: -216,
              y: -91,
            },
          },
        },
        {
          root: SVG.select('#cubes-up-cub-06'),
          transform: {
            translate: {
              x: 96,
              y: -50,
            },
          },
        },
        {
          root: SVG.select('#cubes-up-cub-07'),
          transform: {
            translate: {
              x: -167,
              y: -255,
            },
          },
        },
        {
          root: SVG.select('#cubes-up-cub-08'),
          transform: {
            translate: {
              x: 304,
              y: -308,
            },
          },
        },
        {
          root: SVG.select('#cubes-up-cub-09'),
          transform: {
            translate: {
              x: -367,
              y: -358,
            },
          },
        },
      ];

      this.cubesBottomWrap = SVG.select('#cubes-bottom');
      this.cubesMiddleWrap = SVG.select('#cubes-middle');

      this.cubesTopWrap = SVG.select('#cubes-up');

      for (let p = 1; p < 10; p += 1) {
        const el = SVG.select(`#cubes-middle-cub-0${p}`);
        this.cubesMiddle.push(el);
        el.opacity(0);
      }
      for (let p = 1; p < 10; p += 1) {
        const el = SVG.select(`#cubes-bottom-cub-0${p}`);
        this.cubesBottom.push(el);
        el.opacity(0);
      }
      this.cubesTopWrap.x(4);
      this.checkCurrentTheme();
    },

    checkCurrentTheme() {
      if (this.theme === 'dark') {
        this.darkStatus();
      } else {
        this.whiteStatus();
      }
    },

    whiteStatus() {
      this.clearTimeouts();
      this.disableAnimation = false;
      this.timing = 900;
      for (let m = 0; m < this.cubes.length; m += 1) {
        const el = this.cubes[m];
        el.root.animate(this.timing)
          .x(0)
          .y(0)
          .opacity(1);
      }

      this.clearTransform(this.cubesBottomWrap);
      this.clearTransform(this.cubesMiddleWrap);

      for (let p = 0; p < this.cubesBottom.length; p += 1) {
        const el = this.cubesBottom[p];
        el.animate(this.timing).opacity(0);
      }
      for (let p = 0; p < this.cubesMiddle.length; p += 1) {
        const el = this.cubesMiddle[p];
        el.animate(this.timing).opacity(0);
      }
    },
    darkStatus() {
      this.clearTimeouts();
      for (let m = 0; m < this.cubes.length; m += 1) {
        const el = this.cubes[m];
        el.root.animate(this.timing)
          .x(el.transform.translate.x)
          .y(el.transform.translate.y);
      }
      this.timeoutsAnimation.darkCubes = setTimeout(() => {
        this.cubesMiddleWrap.animate(this.timing).y(-270);

        for (let p = 0; p < this.cubesMiddle.length; p += 1) {
          const el = this.cubesMiddle[p];
          this.timeoutsAnimation[`cubes_${p}`] = setTimeout(() => {
            el.animate(this.timing).opacity(1);
          }, this.disableAnimation ? 0 : p * 100);
        }
      }, this.disableAnimation ? 0 : 1000);

      this.timeoutsAnimation.darkBottom = setTimeout(() => {
        this.cubesBottomWrap.animate(this.timing).y(-270);

        for (let p = 0; p < this.cubesBottom.length; p += 1) {
          const el = this.cubesBottom[p];
          this.timeoutsAnimation[`cubes_bottom_${p}`] = setTimeout(() => {
            el.animate(this.timing).opacity(1);
          }, this.disableAnimation ? 0 : p * 100);
        }
      }, this.disableAnimation ? 0 : 1200);
    },

    clearTransform(el) {
      el.animate(this.timing)
      .x(0)
      .y(0);
      // .opacity(0);
    },

    clearTimeouts() {
      for (let p = 0; p < this.cubesMiddle.length; p += 1) {
        clearTimeout(this.timeoutsAnimation[`cubes_${p}`]);
      }
      for (let p = 0; p < this.cubesBottom.length; p += 1) {
        clearTimeout(this.timeoutsAnimation[`cubes_bottom_${p}`]);
      }
      clearTimeout(this.timeoutsAnimation.darkCubes);
      clearTimeout(this.timeoutsAnimation.darkBottom);
    },
  },
};
</script>


<style>
  .animation.animation-cubes{
    transition: all .3s ease-in-out;
    position: absolute;
    max-width: 420px;
    display: none;
    height: auto;
    width: 30vw;
    opacity: 0;
    right: -1vw;
    opacity: 0;
    top: 2vw;

    &.animation-loaded{
      .page-theme.in-viewport &{
        display: block;
        opacity: 1;
      }
    }

    .page-service &{

      @media (max-width: $mediaSmallScreen) {
        right: -10vw;
      }
      @media (max-width: $mediaIpad) {
        right: -20vw;
      }

      @media (max-width: $mediaMob) {
        right: -28vw;
        top: -10vw;
      }
    }


    svg{
      max-width: 100%;
    }

  }
</style>



// WEBPACK FOOTER //
// src/components/Animation/Cubes.vue